import { IRDSBase } from "../modules/common/database/rds-base/RdsBase";

export function removeDuplicates<T extends IRDSBase<any>>(list: T[]) {
	return [...new Map(list.map((obj) => [obj.id, obj])).values()];
}
